import { batch } from 'react-redux'
import { customizeError, formatDNI, putCookie } from '@chilecompra/react-kit'

import {
  REACT_APP_ACCESS_TOKEN_NAME,
  REACT_APP_ACCESS_TOKEN_NAME_MP
} from '../../config/settings/environment.config'
import { makeActionCreator } from '../../config/store/utils'
import { getAuthInfo } from '../../services/auth'
import { getCookieFromDomain } from '../../utils'

export const GET_AUTH_INFO = 'GET_AUTH_INFO'
export const GET_AUTH_INFO_ERROR = 'GET_AUTH_INFO_ERROR'
export const GET_AUTH_INFO_SUCCESS = 'GET_AUTH_INFO_SUCCESS'
export const onGetAuthInfo = makeActionCreator(GET_AUTH_INFO)
export const onGetAuthInfoError = makeActionCreator(GET_AUTH_INFO_ERROR, 'payload')
export const onGetAuthInfoSuccess = makeActionCreator(GET_AUTH_INFO_SUCCESS, 'payload')
export const onGetAuthInfoThunk = () => async dispatch => {
  dispatch(onGetAuthInfo())

  try {
    const { data } = await getAuthInfo({ actionType: GET_AUTH_INFO })

    const authInfo = {
      business: data.payload?.razonsocial || '',
      dni: formatDNI(data.payload?.rut, 2) || '',
      entCode: data.payload?.codigoEmpresa || '',
      name: data.payload?.name || '',
      orgCode: data.payload?.codigoOrganismo || '',
      roles: data.payload?.roles || [],
      userType: data.payload?.tipoUsuario || 'Publico',
      usrCode: data.payload?.codigoUsuario || ''
    }

    return dispatch(onGetAuthInfoSuccess({ ...authInfo }))
  } catch (error) {
    dispatch(
      onGetAuthInfoError({
        error: customizeError({
          code: error.code,
          originalError: error.originalError,
          reason: 'UNAUTHORIZED_ERROR'
        }).toObject()
      })
    )
  }
}

export const GET_TOKEN = 'GET_TOKEN'
export const GET_TOKEN_ERROR = 'GET_TOKEN_ERROR'
export const GET_TOKEN_SUCCESS = 'GET_TOKEN_SUCCESS'
export const onGetToken = makeActionCreator(GET_TOKEN)
export const onGetTokenError = makeActionCreator(GET_TOKEN_ERROR, 'payload')
export const onGetTokenSuccess = makeActionCreator(GET_TOKEN_SUCCESS, 'payload')
export const onGetTokenThunk = () => async dispatch => {
  dispatch(onGetToken())
  try {
    let accessToken = await Promise.resolve()
      .then(() => getCookieFromDomain(REACT_APP_ACCESS_TOKEN_NAME_MP))
      .catch(() => {
        throw customizeError({
          code: 400,
          reason: 'SOMETHING_WENT_WRONG_ERROR'
        })
      })

    if (!accessToken) {
      accessToken = await Promise.resolve()
        .then(() => getCookieFromDomain(REACT_APP_ACCESS_TOKEN_NAME))
        .catch(() => {
          throw customizeError({
            code: 400,
            reason: 'SOMETHING_WENT_WRONG_ERROR'
          })
        })
    }

    accessToken = accessToken ?? ''
    putCookie(REACT_APP_ACCESS_TOKEN_NAME, accessToken)

    return batch(() => {
      dispatch(onGetTokenSuccess({ accessToken }))
      dispatch(onGetAuthInfoThunk())
    })
  } catch (error) {
    return dispatch(
      onGetTokenError({
        error: customizeError({
          code: error.code,
          originalError: error.originalError,
          reason: error.reason || 'TOKEN_RETRIEVAL_ERROR'
        }).toObject()
      })
    )
  }
}
